__turbopack_context__.v({
  "box": "Loader-module__QTzgNq__box",
  "box2": "Loader-module__QTzgNq__box2",
  "box3": "Loader-module__QTzgNq__box3",
  "box4": "Loader-module__QTzgNq__box4",
  "box5": "Loader-module__QTzgNq__box5",
  "color-change": "Loader-module__QTzgNq__color-change",
  "fullScreen": "Loader-module__QTzgNq__fullScreen",
  "loader": "Loader-module__QTzgNq__loader",
  "logo": "Loader-module__QTzgNq__logo",
  "ripple": "Loader-module__QTzgNq__ripple",
  "wrapper": "Loader-module__QTzgNq__wrapper",
});
